import React from "react";
import "./Style/BarLoader.css"; // For styling

export default function BarLoader({ progress }) {
  const rounded_progress = progress.toFixed(0);
  const getGradient = (progress) => {
    if (progress === 100) return "#00FF00"; // Solid green at 100%

    if (progress <= 10) return "#FFFF00"; // Solid yellow
    if (progress <= 20) return "linear-gradient(to right, #FFFF00, #FFE633)"; // Slightly lighter yellow
    if (progress <= 30) return "linear-gradient(to right, #FFE633, #FFCC66)"; // Yellow-orange mix
    if (progress <= 40) return "linear-gradient(to right, #FFCC66, #E6FF33)"; // Yellow-green mix
    if (progress <= 50) return "linear-gradient(to right, #E6FF33, #CCFF66)"; // Light green
    if (progress <= 60) return "linear-gradient(to right, #CCFF66, #B3FF33)"; // More green
    if (progress <= 70) return "linear-gradient(to right, #B3FF33, #99FF33)"; // Stronger green
    if (progress <= 80) return "linear-gradient(to right, #99FF33, #66FF00)"; // Dominant green
    if (progress <= 90) return "linear-gradient(to right, #66FF00, #33FF00)"; // Almost full green
    if (progress < 100) return "linear-gradient(to right, #33FF00, #00FF00)"; // Near solid green

    return "#00FF00"; // Fallback to solid green
  };

  return (
    <div className="bar-loader-container">
      <div className="bar-loader">
        <div
          className="bar-progress"
          style={{
            width: `${rounded_progress}%`,
            background: getGradient(rounded_progress),
          }}
        ></div>
      </div>
      <span className="percentage">{rounded_progress}%</span>
    </div>
  );
}
